



















































































































import { useMedicos } from '@/composables'
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ComponentFiltrosAgendamentoMedico extends Vue {
  @Prop() canShowDoctorField = true

  @Prop() statuses: { key: string; display: string }[] = []
  @Prop() statusesReservation: { key: string; display: string }[] = []
  @Prop() carateresCirurgias: { key: string; display: string }[] = []
  @Prop() hospitals: { id: string; nome: string }[] = []
  @Prop() totalRecords: number = 0

  filterData: ComponentFiltrosAgendamentoMedicoFilterData = {}

  get doctors() {
    return useMedicos.medicosByInstrumentador
  }

  async fetchDoctors() {
    await useMedicos.loadMedicosByInstrumentador()
  }

  @Emit('filter')
  filter() {
    this.$ga.event('agendamento-medico', 'filtrar-solicitacoes', this.$user.profile.email)
    return this.filterData
  }

  resetFilter() {
    this.filterData = {}
    this.filter()
  }
}

export interface ComponentFiltrosAgendamentoMedicoFilterData {
  doctorId?: string
  patient?: string
  status?: string
  statusReservation?: string
  caraterCirurgia?: string
  hospitals?: string[]
  surgeryStartAt?: string
  surgeryEndAt?: string
}
